import type { SupportFormField } from "@gaole/shared";
import { Input } from "../ui";
import { SupportAttachmentUploadField } from "./SupportAttachmentUploadField";

interface SupportFormFieldInputProps {
  field: SupportFormField;
  value: string;
  onChange: (value: string) => void;
}

export function SupportFormFieldInput({ field, value, onChange }: SupportFormFieldInputProps) {
  if (field.type === "textarea") {
    return (
      <textarea
        rows={3}
        className="w-full rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-xs text-white outline-none focus:border-brand-pink/60"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    );
  }

  if (field.type === "select") {
    return (
      <select
        className="w-full rounded-xl border border-white/10 bg-surface px-3 py-2 text-xs text-white outline-none focus:border-brand-pink/60"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Select…</option>
        {field.options?.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    );
  }

  if (field.type === "date") {
    return (
      <input
        type="date"
        className="w-full rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-xs text-white outline-none focus:border-brand-pink/60"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    );
  }

  if (field.type === "amount") {
    return (
      <Input
        type="number"
        step="0.01"
        min={0}
        placeholder="0.00"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    );
  }

  if (field.type === "file") {
    return <SupportAttachmentUploadField label={field.label} value={value} onChange={onChange} />;
  }

  return (
    <Input
      type={field.type === "number" ? "number" : field.type === "email" ? "email" : "text"}
      placeholder={field.type === "order" ? "e.g. MG-240801-XXXX" : undefined}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}
